/**
 * Selector for all focusable elements in the DOM.
 * Includes links, form elements, buttons, and elements with tabindex or contenteditable.
 */
export const FOCUSABLE_ELEMENTS_SELECTOR =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable]';

export type GetFocusableElementsReturn = {
  elements: NodeListOf<Element>;
  firstElement: HTMLElement | null;
  lastElement: HTMLElement | null;
};

/**
 * Query and return all focusable elements within a container.
 *
 * @param container - The container element to search within
 * @param selector - Optional custom selector (defaults to FOCUSABLE_ELEMENTS_SELECTOR)
 * @returns Object containing all elements, first element, and last element
 */
export function getFocusableElements(container: HTMLElement, selector?: string): GetFocusableElementsReturn {
  const elements = container.querySelectorAll(selector || FOCUSABLE_ELEMENTS_SELECTOR);

  return {
    elements,
    firstElement: (elements[0] as HTMLElement) || null,
    lastElement: (elements[elements.length - 1] as HTMLElement) || null,
  };
}
